import { styled } from '@mui/material/styles';

export const StyledHighlightedTextMarker = styled('span')<{ isCurrentHighlight: boolean }>(({ isCurrentHighlight }) => ({
  backgroundColor: '#fce4a9',
  display: 'inline',
  position: 'relative',
  ...(isCurrentHighlight && {
    outline: '2px solid #1976d2',
    outlineOffset: '0px',
  }),
  '& > span': {
    backgroundColor: 'inherit',
    display: 'inline',
    position: 'relative',
  },
}));
